<div
	class="freya-event-container"
	[class.freya-event-hidden]="hidden"
>
	<div
		class="freya-calendar-event freya-availability-event"
		[class.freya-event-hidden]="hidden"
		style="width: 100%;"
		[style.background-image]="child ? 'none' : ''"
	>
	</div>
</div>